import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import i18n from './../../shared/i18n';
import i18nHelper from "@/core/services/i18n.service";
import {store} from "@/plugins/vuex";
import {Formatter} from "@/core/services/formatter.service";

export default class IntroductorySettlementModel extends BaseModel {
  uuid = null;
  customer_uuid = null;
  auction_uuid = null;
  sale_no = null;
  settled_introductory_financial_items = [];
  unsettled_introductory_financial_items = [];
  preferred_language_code = null;
  additional_page = false;
  date = Formatter.getCurrentDate();
  rules = {
    preferred_language_code: 'required',
    customer_uuid: 'required',
    auction_uuid: store.state.global.enableContinuousAuction ? '' : 'required',
    lot_uuid: store.state.global.enableContinuousAuction ? 'required' : '',
  };
  settlement_billing_address = null;

  attributeLabels = {
    no: i18n.t('No'),
    data: i18n.t('Data'),
    bidder: i18n.t('Bidder'),
    branch: i18n.t('Branch'),
    status: i18n.t('Status'),
    auction: i18n.t('Auction'),
    currency: i18n.t('Currency'),
    customer_uuid: i18n.t('Customer'),
    auction_uuid: i18n.t('Sale Number'),
    lot_uuid: i18n.t('Lot Number'),
    preferred_language_code: i18n.t('Preferred Language'),
    additional_page: i18n.t('Charges Breakdown'),
    date: i18n.t('Date'),
  };

  attributePlaceholders = this.attributeLabels;

  attributeHints = {
    preferred_language_code: i18n.t('Settlement template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();

    Object.assign(this, {...data});
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
  }
}

defineTranslatableProperties(IntroductorySettlementModel);
